var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDopplerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 30,
    viewBox: "0 0 21 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.54283e-06 1.12714e-06C2.75776 1.02468e-06 5.48851 0.387988 8.03635 1.14181C10.5842 1.89563 12.8992 3.00052 14.8492 4.3934C16.7993 5.78628 18.3461 7.43987 19.4015 9.25975C20.4568 11.0796 21 13.0302 21 15C21 16.9698 20.4568 18.9204 19.4015 20.7403C18.3461 22.5601 16.7993 24.2137 14.8492 25.6066C12.8992 26.9995 10.5842 28.1044 8.03635 28.8582C5.48851 29.612 2.75776 30 -1.90735e-06 30L-7.71413e-07 15L-1.54283e-06 1.12714e-06Z",
    fill: "#122A01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDopplerLogo);
export default __webpack_public_path__ + "static/media/doppler_logo.a0561d84687d18105667c7fb93b0d5a9.svg";
export { ForwardRef as ReactComponent };